<template>
    <div class="ReportRepair" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>报事报修管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                         <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible"
                            popper-class="queryReportRepair">
                            <el-form>
                                <el-form-item label="开始时间" label-width="80px" prop="status">
                                    <el-date-picker
                                        ref="dateS"
                                        v-model="dateS"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="结束时间" label-width="80px" prop="status">
                                    <el-date-picker
                                        ref="dateE"
                                        v-model="dateE"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="工单状态" label-width="80px" prop="status">
                                    <el-select v-model="status" clearable placeholder="请选择">
                                        <el-option v-for="item in StatusList" :key="item.id" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="人员" label-width="80px">
                                    <el-select v-model="admin_id" placeholder="请选择人员">
                                        <el-option :key="item.id" v-for="item in personnelData" :label="item.username" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否有偿" label-width="80px">
                                    <el-select v-model="is_youchang" placeholder="请选择" clearable>
                                        <el-option label="是" :value="1"></el-option>
                                        <el-option label="否" :value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <!-- is_youchang -->
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="ExportReportRepair">导出</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :data="tableData" :height="Height - 247" border style="width: 100%">
                    <!-- <el-table-column prop="area" label="报修区域">
                    </el-table-column> -->
                    <el-table-column prop="type" label="报修类型">
                    </el-table-column>
                    <el-table-column prop="create_time" label="报修时间">
                    </el-table-column>
                    <el-table-column prop="address" label="报修地点" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="contact" label="报修人">
                    </el-table-column>
                    <el-table-column prop="company_name" label="报修人公司" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="tel" label="报修人手机号">
                    </el-table-column>
                    <el-table-column prop="intro" label="报修描述" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="status" label="报修状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 0">待处理</span>
                            <!-- <span v-if="scope.row.status === 0 && !scope.row.admin_name">未分配</span>
                            <span v-if="scope.row.status === 0 && scope.row.admin_name">已分配</span> -->
                            <span v-if="scope.row.status === 1">处理中</span>
                            <span v-if="scope.row.status === 2">已处理</span>
                            <span v-if="scope.row.status === 3">已完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="admin_name" label="维修人员">
                    </el-table-column>
                    <el-table-column prop="telephone" label="维修人员电话">
                    </el-table-column>
                    <el-table-column prop="address" label="操作" width="160px">
                        <template slot-scope="scope">
                            <el-button type="text" @click="ViewWorkOrder(scope.row)">查看工单</el-button>
                            <el-button v-if="scope.row.status !== 2 && scope.row.status !== 3" type="text" @click="AssignPersonnel(scope.row)">分配人员</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-drawer
                    :title="WorkOrderData.area + '-' + WorkOrderData.type + '维修'"
                    :visible.sync="drawer"
                    direction="rtl"
                    @opened="DrawerEnd">
                    <div class="intro">
                        <span>{{WorkOrderData.intro}}</span>
                    </div>
                    <div class="TechnologicalProcess" :style="{'min-height': Height - 105 + 'px'}">
                        <div class="SpeedOfProgress">
                            <el-row>
                                <el-col>
                                    <i class="el-icon-time"></i>
                                    <span>处理进度</span>
                                </el-col>
                            </el-row>
                            <div class="Progress">
                                <el-timeline>
                                    <el-timeline-item :color="item.color" size="large" :timestamp="item.title" placement="top" :key="item.id" v-for="(item, index) in WorkOrderData.TechnologicalProcess">
                                        <ul style="border-bottom: 1px solid #999;">
                                            <li v-if="item.intro !== '' && item.intro !== undefined && item.intro !== null">
                                                <span>{{item.intro}}</span>
                                            </li>
                                            <li style="min-height: 20px;">
                                                <span style="float: left; width: 100px;" v-if="Number(index) + 1 === WorkOrderData.TechnologicalProcess.length">报修人：</span>
                                                <span style="float: left; width: 100px;" v-if="Number(index) + 1 !== WorkOrderData.TechnologicalProcess.length">操作人：</span>
                                                <div style="text-align: right; margin-left: 100px;">
                                                    {{item.contact}}
                                                </div>
                                            </li>
                                            <li style="min-height: 20px;" v-if="item.is_youchang !== undefined && item.is_youchang !== null">
                                                <span style="float: left; width: 100px;">服务类型：</span>
                                                <div style="text-align: right; margin-left: 100px;">
                                                    <!-- {{item.tel}} -->
                                                    <span v-if="item.is_youchang === 0">无偿服务</span>
                                                    <span v-if="item.is_youchang === 1">有偿服务</span>
                                                    <span v-if="item.is_youchang === 1" style="margin-left: 10px; color: #409EFF; cursor: pointer;" @click="ViewDetails">查看详情</span>
                                                </div>
                                            </li>
                                            <li style="min-height: 20px;" v-if="item.tel !== undefined && item.tel !== null">
                                                <span style="float: left; width: 100px;">报修人电话：</span>
                                                <div style="text-align: right; margin-left: 100px;">
                                                    {{item.tel}}
                                                </div>
                                            </li>
                                             <li style="min-height: 20px;" v-if="item.company_name !== undefined && item.company_name !== null">
                                                <span style="float: left; width: 100px;">报修人公司：</span>
                                                <div style="text-align: right; margin-left: 100px;">
                                                    {{item.company_name}}
                                                </div>
                                            </li>
                                            <li style="min-height: 20px;" v-if="item.remark !== undefined && item.remark !== null">
                                                <span style="float: left; width: 100px;">备注：</span>
                                                <div style="text-align: right; margin-left: 100px;">
                                                    {{item.remark}}
                                                </div>
                                            </li>
                                            <li style="min-height: 20px;" v-if="item.user_comment !== undefined && item.user_comment !== null">
                                                <span style="float: left; width: 100px;">评价：</span>
                                                <div style="text-align: right; margin-left: 100px;">
                                                    {{item.user_comment}}
                                                </div>
                                            </li>
                                            <li style="min-height: 20px;">
                                                <span style="float: left; width: 100px;">{{item.datetitle}}：</span>
                                                <div style="text-align: right; margin-left: 100px;">
                                                    {{item.create_time}}
                                                </div>
                                            </li>
                                            <li v-if="item.imgs !== undefined && item.imgs !== null && item.imgs.length !== 0">
                                                <img style="margin-right: 10px; cursor:pointer;" height="100px" :key="items.id" v-for="items in item.imgs" :src="http + items.response" @click="clickEnlarge(items)">
                                            </li>
                                        </ul>
                                    </el-timeline-item>
                                     <!-- <el-timeline-item color="#cccccc" size="large" timestamp="维修中" placement="top">
                                        <ul style="border-bottom: 1px solid #999;">
                                            <li>
                                                <span>空调已维修好，已制冷</span>
                                            </li>
                                            <li>
                                                操作人： 维修工
                                            </li>
                                            <li>
                                                完成时间： 维修工
                                            </li>
                                        </ul>
                                    </el-timeline-item>
                                     <el-timeline-item color="#cccccc" size="large" timestamp="待受理" placement="top">
                                        <ul style="border-bottom: 1px solid #999;">
                                            <li>
                                                <span>空调已维修好，已制冷</span>
                                            </li>
                                            <li>
                                                操作人： 维修工
                                            </li>
                                            <li>
                                                完成时间： 维修工
                                            </li>
                                        </ul>
                                    </el-timeline-item> -->
                                </el-timeline>
                            </div>
                        </div>
                    </div>
                </el-drawer>
                <el-dialog title="分配人员" :visible.sync="AssignPersonneldialog" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="AssignPersonneldialog">
                    <el-form ref="formrules" :model="form" :rules="rules">
                        <el-form-item label="人员" label-width="80px" prop="admin_id">
                            <el-select v-model="form.admin_id" placeholder="请选择人员">
                                <el-option :key="item.id" v-for="item in personnelData" :label="item.username" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="AssignPersonneldialog = false">取 消</el-button>
                        <el-button type="primary" @click="confirmAssignPersonneldialog" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog :visible.sync="enlarge" width="500px"  custom-class="enlarge">
                    <img width="200px" :src="http + url">
                </el-dialog>
                <el-dialog :visible.sync="ServiceDetailShow" width="500px"  custom-class="ServiceDetailShow" title="服务详情">
                    <el-table :data="detailsData" border style="width: 100%" height="300px">
                        <el-table-column prop="title" label="名称">
                        </el-table-column>
                        <el-table-column prop="num" label="规格数量" width="100px">
                        </el-table-column>
                        <el-table-column prop="amount" label="小计" width="120px" align="right">
                            <template slot-scope="scope">
                                <span>{{get_thousand_num(scope.row.amount)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <img width="200px" :src="http + url"> -->
                </el-dialog>
            </el-main>
            <el-footer height="40px">
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "ReportRepair",
    data () {
        return {
            http: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            currentPage: 1,
            Size: 20,
            total: 0,
            status: '',
            StatusList: [{
                label: '待处理',
                value: 0
            }, {
                label: '处理中',
                value: 1
            }, {
                label: '已处理',
                value: 2
            }],
            WorkOrderData: {},
            drawer: false,
            AssignPersonneldialog: false,
            form: {
                admin_id: ''
            },
            rules: {
                admin_id: [
                    { required: true, message: '请选择人员', trigger: 'blur' }
                ]
            },
            confirmloding: false,
            personnelData: [],
            dateS: '',
            dateE: '',
            admin_id: '',
            enlarge: false,
            url: '',
            ServiceDetailShow: false,
            detailsData: [],
            is_youchang: ''
        }
    },
    mounted() {
        // this.dateS
        // this.dateE
        // this.$refs.dateS.$el.firstElementChild.onclick = function (e) {
        //     console.log(e)
        //     this.visible = true
        // }
        // this.$refs.dateS.$el.onclick = function (e) {
        //     console.log(e)
        //     this.visible = true
        // }
        // this.$refs.dateE.$el.firstElementChild.onclick = function (e) {
        //     console.log(e)
        //     this.visible = true
        // }
        // this.$refs.dateE.$el.onclick = function (e) {
        //     console.log(e)
        //     this.visible = true
        // }
    },
    watch: {

    },
    methods: {
        // 导出
        ExportReportRepair () {
            let that = this
            this.fullscreenLoading = true
            let data = {
                limit: this.Size,
                page: this.currentPage,
                admin_id: this.admin_id,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                dateS: this.dateS,
                dateE: this.dateE,
                is_youchang: this.is_youchang,
                is_excel: 1
            }
            if (this.status !== '') {
                data.status = this.status
            }
            this.$store.dispatch('ExportReportRepair', data).then(res => {
                let link = document.createElement('a')
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.download = '报事报修单' // 下载的文件名
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.fullscreenLoading = false
            })
        },
        ViewDetails () {
            console.log(this.WorkOrderData)
            let data = {
                id: this.WorkOrderData.id
            }
            this.detailsData = []
            this.$store.dispatch('ViewDetails', data).then(res => {
                this.detailsData = res.data
                this.ServiceDetailShow = true
            })
        },
        AddBooking () {
        },
        handleSizeChange (size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetReportRepairList()
        },
        handleCurrentChange (page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetReportRepairList()
        },
        GetReportRepairList () {
            let data = {
                limit: this.Size,
                page: this.currentPage,
                admin_id: this.admin_id,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                dateS: this.dateS,
                dateE: this.dateE,
                is_youchang: this.is_youchang
            }
            if (this.status !== '') {
                data.status = this.status
            }
            this.$store.dispatch('ReportRepairListShow', data).then(res => {
                this.fullscreenLoading = false
                this.visible = false
                this.total = res.something
                this.tableData = res.data
                for (let item in this.tableData) {
                    this.tableData[item].TechnologicalProcess = []
                    if (this.tableData[item].status === 0) {
                        let obj = {
                            create_time: this.tableData[item].create_time,
                            title: '待受理',
                            contact: this.tableData[item].contact,
                            imgs: JSON.parse(this.tableData[item].imgs),
                            color: '#E6A23C',
                            datetitle: '报修时间',
                            company_name: this.tableData[item].company_name,
                            tel: this.tableData[item].tel
                        }
                        this.tableData[item].TechnologicalProcess.push(obj)
                    } else if (this.tableData[item].status === 1) {
                        let obj1 = {
                            create_time: this.tableData[item].create_time,
                            title: '待受理',
                            contact: this.tableData[item].contact,
                            imgs: JSON.parse(this.tableData[item].imgs),
                            datetitle: '报修时间',
                            company_name: this.tableData[item].company_name,
                            tel: this.tableData[item].tel
                        }
                        let obj2 = {
                            create_time: this.tableData[item].deal_time,
                            title: '处理中',
                            color: '#E6A23C',
                            contact: this.tableData[item].admin_name,
                            datetitle: '维修开始时间'
                        }
                        this.tableData[item].TechnologicalProcess.push(obj2)
                        this.tableData[item].TechnologicalProcess.push(obj1)
                    } else if (this.tableData[item].status === 2) {
                        let obj1 = {
                            create_time: this.tableData[item].create_time,
                            title: '待受理',
                            contact: this.tableData[item].contact,
                            imgs: JSON.parse(this.tableData[item].imgs),
                            datetitle: '报修时间',
                            company_name: this.tableData[item].company_name,
                            tel: this.tableData[item].tel
                        }
                        let obj2 = {
                            create_time: this.tableData[item].deal_time,
                            title: '处理中',
                            contact: this.tableData[item].admin_name,
                            datetitle: '维修开始时间'
                        }
                        let obj3 = {
                            create_time: this.tableData[item].deal_time,
                            title: '已处理',
                            color: '#E6A23C',
                            remark: this.tableData[item].remark,
                            contact: this.tableData[item].admin_name,
                            is_youchang: this.tableData[item].is_youchang,
                            datetitle: '维修完成时间',
                            imgs: JSON.parse(this.tableData[item].pics)
                        }
                        this.tableData[item].TechnologicalProcess.push(obj3)
                        this.tableData[item].TechnologicalProcess.push(obj2)
                        this.tableData[item].TechnologicalProcess.push(obj1)
                    } else if (this.tableData[item].status === 3) {
                        let obj1 = {
                            create_time: this.tableData[item].create_time,
                            title: '待受理',
                            contact: this.tableData[item].contact,
                            imgs: JSON.parse(this.tableData[item].imgs),
                            datetitle: '报修时间',
                            company_name: this.tableData[item].company_name,
                            tel: this.tableData[item].tel
                        }
                        let obj2 = {
                            create_time: this.tableData[item].deal_time,
                            title: '处理中',
                            contact: this.tableData[item].admin_name,
                            datetitle: '维修开始时间'
                        }
                        let obj3 = {
                            create_time: this.tableData[item].deal_time,
                            title: '已处理',
                            remark: this.tableData[item].remark,
                            contact: this.tableData[item].admin_name,
                            is_youchang: this.tableData[item].is_youchang,
                            datetitle: '维修完成时间',
                            imgs: JSON.parse(this.tableData[item].pics)
                        }
                        let obj4 = {
                            title: '已完成',
                            color: '#E6A23C',
                            contact: this.tableData[item].admin_name,
                            user_comment: this.tableData[item].user_comment,
                            datetitle: '满意度',
                            create_time: ''
                        }
                        if (this.tableData[item].user_rt === 1) {
                            obj4.create_time = '满意'
                        } else if (this.tableData[item].user_rt === 0) {
                            obj4.create_time = '不满意'
                        }
                        this.tableData[item].TechnologicalProcess.push(obj4)
                        this.tableData[item].TechnologicalProcess.push(obj3)
                        this.tableData[item].TechnologicalProcess.push(obj2)
                        this.tableData[item].TechnologicalProcess.push(obj1)
                    }
                }
            })
        },
        get_thousand_num (num) {
            return num.toString().replace(/\d+/, function (n) { // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
                    return $1 + ','
                })
            })
        },
        ViewWorkOrder(row) {
            this.WorkOrderData = JSON.parse(JSON.stringify(row))
            console.log(this.WorkOrderData)
            this.drawer = true
        },
        AssignPersonnel(row) {
            this.WorkOrderData = JSON.parse(JSON.stringify(row))
            this.form.admin_id = row.admin_id
            this.AssignPersonneldialog = true
        },
        confirmAssignPersonneldialog () {
            let that = this
            this.confirmloding = true
            this.$refs['formrules'].validate((valid) => {
                if (valid) {
                    console.log(valid)
                    let data = {
                        id: that.WorkOrderData.id,
                        admin_id: that.form.admin_id,
                        ADMIN_ID: getAdminId(),
                        ADMIN_TOKEN: getToken(),
                        fenpei_id: getAdminId()
                    }
                    that.$store.dispatch('confirmAssignPersonneldialog', data).then(res => {
                        that.confirmloding = false
                        if (res.flag) {
                            that.fullscreenLoading = true
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.AssignPersonneldialog = false
                            that.GetReportRepairList()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                        let data = {
                            ADMIN_ID: getAdminId(),
                            ADMIN_TOKEN: getToken()
                        };
                        this.$store.dispatch("Isread", data).then(res => {
                            console.log(res);
                        });
                    })
                } else {
                    that.confirmloding = false
                    return false;
                }
            });
        },
        Reset() {
            this.status = ''
            this.dateS = ''
            this.dateE = ''
            this.admin_id = ''
            this.is_youchang = ''
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.fullscreenLoading = true
            this.GetReportRepairList()
        },
        DrawerEnd () {
            console.log(document.getElementsByClassName('el-timeline-item__node'))
        },
        clickEnlarge (row) {
            this.enlarge = true
            this.url = row.response
        }
    },
    created() {
        this.fullscreenLoading = true
        let data = {
            admin_id: getAdminId(),
            ADMIN_ID: getAdminId(),
            ADMIN_TOKEN: getToken()
        }
        this.$store.dispatch('personnelShow', data).then(res => {
            this.personnelData = res.data
        })
    this.GetReportRepairList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.ReportRepair {
    width: 100%;
}
.ReportRepair .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.ReportRepair .el-header .el-row .el-col h2 {
    text-align: center;
}
.ReportRepair .el-header .el-row .el-col {
    text-align: center;
}
.ReportRepair .el-header .el-row .el-col:last-child {
    text-align: right;
}
.ReportRepair .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body {
    color: #666;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .intro {
    min-height: 30px;
    padding: 0px 20px;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess {
    background-color: #f4f4f4;
    overflow: auto;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess .SpeedOfProgress {
    background-color: #fff;
    margin-top: 20px;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess .SpeedOfProgress .el-row .el-col {
    height: 40px;
    line-height: 40px;
    padding: 0px 20px;
    border-bottom: 1px solid #999;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess .SpeedOfProgress .el-row .el-col i {
    font-size: 26px;
    margin-top: 5px;
    margin-right: 5px;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess .SpeedOfProgress .el-row .el-col span {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    vertical-align: top;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess .SpeedOfProgress .Progress {
    padding: 20px 20px 0;
}
.ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess .SpeedOfProgress .Progress .el-timeline-item__content ul li {
    margin: 8px 0px;
    display: block;
}
/* .ReportRepair .el-main .el-drawer__container .el-drawer__body .TechnologicalProcess .SpeedOfProgress .Progress .el-timeline-item__content ul li div {
    
} */
.queryReportRepair .el-select, .queryReportRepair .el-form-item__content .el-date-editor {
    width: 100%;
}
.ReportRepair .el-main .AssignPersonneldialog .el-select {
    width: 100%;
}
.ReportRepair .el-main .enlarge .el-dialog__body {
    text-align: center;
}
.ServiceDetailShow .el-dialog__body {
    padding-top: 0px;
}
</style>
